import { useMemo } from 'react';
import { useSubscription } from '@apollo/client';

import mockedData from './demo';
import getOperationDefinition from './utils/getOperationDefinition';

function useSubscriptionMock(query, options) {
  const name = getOperationDefinition(query);
  const subscriptionFunction = mockedData[name];

  const subscription = useMemo(() => {
    if (!subscriptionFunction) {
      // eslint-disable-next-line no-console
      console.error('Could not get subscription ', name);
      return undefined;
    }

    const sub = subscriptionFunction(options.variables);
    sub.onData((payload) => {
      const data = payload?.data || payload;
      if (options.onData) {
        options.onData({ data, loading: false, error: null });
      } else if (options.onSubscriptionData) {
        options.onSubscriptionData({ subscriptionData: { data } });
      }
    });
    return sub;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return subscription;
}

const useMockableSubscription = process.env.REACT_APP_IS_DEMO
  ? useSubscriptionMock
  : useSubscription;

export default useMockableSubscription;
